<template>
    <div class="roomtype-outer-container-xs">
        <div class="roomtype-empty-container-xs" @click="closeModal"></div>
        <transition
            appear
            enter-active-class="animate__animated animate__slideInUp"
            leave-active-class="animate__animated animate__slideOutDown"
        >
            <div class="roomtype-inner-container-xs">
                <div>
                    <p class="fsz-20 primary-color fw-bold text-center">Roomtype</p>
                    <div class="roomtype-close-btn-xs" @click="closeModal">
                        <img src="../assets/close-modal-icon.svg" alt="" />
                    </div>
                </div>
                <div>
                    <div
                        class="primary-color fsz-12 mt-4 m-bottom-5 w-100 d-flex justify-content-center"
                    >
                        Choose Your Roomtype <span class="fw-bold">&nbsp;(Max. 3 Type)</span>
                    </div>
                    <div class="roomtype-items-outer-container-xs">
                        <div
                            v-for="(roomType, index) in roomTypes"
                            :key="index"
                            :class="[roomtypeItemClass(roomType.id)]"
                            @click="selectRoomType(roomType)"
                        >
                            <div class="roomtype-items-checkbox-container-xs">
                                <div :class="[roomtypeCheckboxClass(roomType.id)]"></div>
                            </div>
                            <p class="ms-2">{{ roomType.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="roomtype-notification-container-xs">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from '@/components/snacks/index.vue';
export default {
    components: {
        Notification,
    },
    data() {
        return {
            selectedRoomTypeId: [],
            showNotification: false,
            notificationMessage: '',
            notificationStatus: '',
        };
    },
    computed: {
        ...mapState({
            roomTypes: (state) => state.vsStore.roomTypes,
            selectedRoomTypes: (state) => state.vsStore.selectedRoomTypes,
        }),
    },
    mounted() {
        this.selectedRoomTypes.map((item) => {
            this.selectedRoomTypeId.push(item.id);
        });
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        roomtypeItemClass(id) {
            if (this.handleFindIndex(id) >= 0) {
                return 'roomtype-items-active-container-xs';
            }
            return 'roomtype-items-inactive-container-xs';
        },
        roomtypeCheckboxClass(id) {
            if (this.handleFindIndex(id) >= 0) {
                return 'roomtype-items-checkbox-active-xs';
            }
            return 'roomtype-items-checkbox-inactive-xs';
        },
        selectRoomType(roomType) {
            let payload = {};
            if (this.handleFindIndex(roomType.id) < 0) {
                if (this.selectedRoomTypes.length > 2) {
                    this.showNotification = true;
                    this.notificationStatus = 'warning';
                    this.notificationMessage = 'You can not select more than three options';
                    setTimeout(() => {
                        this.showNotification = false;
                    }, 3000);
                    return;
                }
                payload.type = 'add';
                payload.roomType = roomType;
                this.$store.commit('HANDLE_SELECTED_ROOMTYPE', payload);
                return;
            }
            payload.type = 'remove';
            payload.roomType = roomType;
            payload.roomTypeIndex = this.handleFindIndex(roomType.id);
            this.$store.commit('HANDLE_SELECTED_ROOMTYPE', payload);
        },
        handleFindIndex(id) {
            const roomTypeIndex = this.selectedRoomTypes.findIndex((roomtype) => {
                return roomtype.id === id;
            });
            return roomTypeIndex;
        },
    },
};
</script>

<style lang="scss" scoped>
.roomtype {
    &-outer-container-xs {
        position: fixed;
        inset: 0;
        bottom: 0;
        background-color: rgba($color: #888, $alpha: 0.7);
        z-index: 100;
    }
    &-empty-container-xs {
        width: 100%;
        height: calc(100vh - 300px);
    }
    &-inner-container-xs {
        width: 100%;
        height: 320px;
        overflow-y: auto;
        position: absolute;
        bottom: 0;
        border-top-right-radius: 24px;
        border-top-left-radius: 24px;
        padding: 16px;
        background-color: $Background-Color;
    }
    &-close-btn-xs {
        position: absolute;
        top: 24px;
        right: 24px;
    }
    &-items {
        &-outer-container-xs {
            display: grid;
            grid-template-columns: auto auto;
            row-gap: 8px;
        }
        &-active-container-xs {
            display: flex;
            align-items: center;
            height: 32px;
            border-radius: 32px;
            margin-right: 8px;
            color: $Primary-Text-Color;
            font-size: 12px;
            padding: 0 24px;
            line-height: 32px;
            background-color: rgba($color: $Accent-Light-Color, $alpha: 0.2);
            transition: background-color 0.7s;
        }
        &-inactive-container-xs {
            display: flex;
            align-items: center;
            height: 32px;
            border-radius: 32px;
            margin-right: 8px;
            color: $Primary-Text-Color;
            font-size: 12px;
            padding: 0 24px;
            line-height: 32px;
            transition: background-color 0.7s;
        }
        &-checkbox {
            &-container-xs {
                display: flex;
                align-items: center;
                position: relative;
                width: 16px;
                height: 16px;
            }
            &-input-xs {
                position: absolute;
                width: 16px;
                height: 16px;
                z-index: 5;
                opacity: 0;
            }
            &-active-xs {
                width: 16px;
                height: 16px;
                border-radius: 4px;
                background-image: url('../assets/tick-checkbox.svg');
                background-position: center;
                background-size: contain;
                box-shadow: 0px 4px 5px rgba(24, 36, 133, 0.25);
            }
            &-inactive-xs {
                width: 16px;
                height: 16px;
                border-radius: 4px;
                background-color: $Place-Holder-Color;
                position: absolute;
                top: 0;
            }
        }
    }
    &-notification {
        &-container-xs {
            width: 330px;
            position: fixed;
            bottom: 20px;
            right: 10px;
        }
    }
}
</style>
